var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconSaveSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#004B91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8326 4.70505C12.0558 4.97844 12.0558 5.42243 11.8326 5.69583L7.26169 11.295C7.0385 11.5683 6.67604 11.5683 6.45285 11.295L4.16739 8.49539C3.9442 8.222 3.9442 7.778 4.16739 7.50461C4.39058 7.23121 4.75304 7.23121 4.97623 7.50461L6.85816 9.80769L11.0256 4.70505C11.2487 4.43165 11.6112 4.43165 11.8344 4.70505H11.8326Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconSaveSuccess);
export default __webpack_public_path__ + "static/media/SDS_icon_SaveSuccess.ac3378fa99f442be4f87359a9ba93f35.svg";
export { ForwardRef as ReactComponent };